export default "__VITE_ASSET__DJjQNnGt__"